import AdminComp from "../components/AdminComp"

function AdminPage() {
    return <div className="">
        <AdminComp />
    </div>
}

export default AdminPage;